import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormInput from 'components/forms/FormInput';

class ClientCarData extends EntityPropsUpdater {
  updateBrand = (fieldName, brand) => {
    this.updateEntityMultiple(['brandId', 'brandName', 'brand'], [brand.id, brand.name, brand], [[], [], ['item']]);
  };

  updateModel = (fieldName, model) => {
    this.updateEntityMultiple(['modelId', 'modelName', 'model'], [model.id, model.name, model], [[], [], ['item']]);
  };

  updateVin = (fieldName, vin) => {
    this.updateEntityMultiple(['vin', 'vin'], [vin, vin], [[], ['item', 'ident']]);
  };

  updateLicensePlateNumber = (fieldName, licensePlateNumber) => {
    this.updateEntityMultiple(
      ['licensePlateNumber', 'licensePlateNumber'],
      [licensePlateNumber, licensePlateNumber],
      [[], ['item', 'ident']]
    );
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      inModal,
    } = this.props;

    return (
      <div class="clearfix">
        {entityLoaded ? (
          <Row>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.car}</p>
                  <div class="form-group-attached">
                    <FormAutocomplete
                      label={messages.brand}
                      name="brand"
                      value={{ value: entity.getBrandId(), label: entity.getBrandName() }}
                      meta={entity.getBrandIdMetaInformation()}
                      validation={entity.getBrandIdValidationResult()}
                      onChange={this.updateBrand}
                      returnValueObject
                      autocompleteType="brand"
                      disabled={disabled}
                    />
                    <FormAutocomplete
                      urlFilters={entity.getBrandId() ? { filters: { brand: entity.getBrandId() } } : {}}
                      label={messages.model}
                      name="model"
                      value={{ value: entity.getModelId(), label: entity.getModelName() }}
                      meta={entity.getModelIdMetaInformation()}
                      validation={entity.getModelIdValidationResult()}
                      onChange={this.updateModel}
                      returnValueObject
                      autocompleteType="model"
                      disabled={disabled}
                    />
                    <FormInput
                      label={messages.name}
                      name="name"
                      value={entity.getName()}
                      meta={entity.getNameMetaInformation()}
                      validation={entity.getNameValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormInput
                      label={messages.vin}
                      name="vin"
                      value={entity.getVin()}
                      meta={entity.getVinMetaInformation()}
                      validation={entity.getVinValidationResult()}
                      onChange={this.updateVin}
                      disabled={disabled}
                    />
                    <FormInput
                      label={messages.license_plate_number}
                      name="licensePlateNumber"
                      value={entity.getLicensePlateNumber()}
                      meta={entity.getLicensePlateNumberMetaInformation()}
                      validation={entity.getLicensePlateNumberValidationResult()}
                      onChange={this.updateLicensePlateNumber}
                      disabled={disabled}
                    />
                    <FormInput
                      label={messages.mileage}
                      name="mileage"
                      value={entity.getMileage()}
                      meta={entity.getMileageMetaInformation()}
                      validation={entity.getMileageValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      prefixAddon="km"
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        ) : null}
      </div>
    );
  }
}
ClientCarData.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
  };
};
export default withRouter(injectIntl(connect(mapStateToProps)(ClientCarData)));
